import styled from "styled-components";
import themes from "@/styles/themes";
import {ChangeEventHandler, MouseEventHandler, useEffect, useState} from "react";

const LabelStyle = styled.label`
  pointer-events: none;
  color: ${themes.estadao};
  font-size: 16px;
  position: absolute;
  top: 23px;
  left: 15px;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;

  &.cvv {
    font-size: 14px;
    top: 15px;
    left: 11px;
  }
`

const LabelAlert = styled.label`
  pointer-events: none;
  color: ${themes.red};
  font-size: 16px;
  position: absolute;
  top: 15px;
  right: 15px;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;
  display: none;
`

const FormGroup = styled.div`
  position: relative;

  &.group-invalid {
    input.input {
      border: 1px solid ${themes.red} !important;
    }

    span.error {
      color: ${themes.redDark};
      font-size: 12px;
      margin: 0;
      padding: 0;
    }


    ${LabelStyle} {
      color: ${themes.red} !important;
    }

    ${LabelAlert} {
      display: block;
    }
  }

  &.group-valid {
    input.input {
      border: 1px solid ${themes.green};
      box-shadow: 0 0 5px ${themes.green};
    }

    span.error {
      display: none;
    }


    ${LabelStyle} {
      color: ${themes.green} !important;
    }
  }

  input.input {
    border: 1px solid ${themes.estadao};
    border-radius: 5px;
    outline: none;
    width: 100%;
    font-size: 16px;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
    -moz-transition: all .3s ease-out;
    -webkit-appearance: none;
    padding-top: 12px;
    padding-left: 12px;
    margin-top: 8px;
    height: 50px;

    &:focus {
      box-shadow: 0 0 0 2px rgba(37, 117, 232, .3);
    }

    &::placeholder {
      color: transparent;
    }

    &:required:invalid + ${LabelStyle} {
      color: ${themes.red};
    }

    &:focus:required:invalid {
      
      border-bottom: 2px solid ${themes.red};
    }

    &:required:invalid + ${LabelStyle}:before {

      content: '*';
    }

    &:focus + ${LabelStyle},
    &:not(:placeholder-shown) + ${LabelStyle} {
      font-size: 12px;
      margin-top: -10px;
      margin-left: 0;

      color: ${themes.estadao};
    }
  }`

interface IInputProps{
  name: string
  className: string
  type: string
  error: boolean
  message: string
  submited: boolean
  id: string
  placeholder: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  onClick?: MouseEventHandler<HTMLInputElement>
}

export default function Input(parent: IInputProps) {
    const [showError, setShowError] = useState(false)
    const [message, setMessage] = useState('')
    const [groupClasses,setGroupClasses] = useState('')

    useEffect(() => {
        setShowError(parent.error)
        setMessage(parent.message)
        if (parent.error) {
            setGroupClasses('group-invalid')
        } else if (parent.submited && !parent.error) {
            setGroupClasses('group-valid')
        }
    }, [parent]);

    return (
        <FormGroup className={groupClasses}>
            <input name={parent.name} className={`input ${parent.name} ${parent.className}`} type={parent.type}
                   id={parent.id} onChange={parent.onChange} placeholder={parent.placeholder} onClick={parent.onClick}/>
            <LabelStyle htmlFor={parent.name}>{parent.placeholder}</LabelStyle>
            {showError && <span className={'error'}>{message}</span>}
        </FormGroup>
    )
}